<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="dateRange" label="日期范围">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="userId" label="报销人">
        <el-select v-model="searchModel.userId" placeholder="请选择" filterable clearable @change="getTableData(true)">
          <el-option v-for="item in userOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="warning" @click="handleExport">导出报销明细</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="occTime" label="日期" min-width="120" align="center"></el-table-column>
        <el-table-column prop="address" label="地点" align="center"></el-table-column>
        <el-table-column prop="exp1" label="交通费" align="center"></el-table-column>
        <el-table-column prop="exp2" label="住宿费" align="center"></el-table-column>
        <el-table-column prop="exp3" label="租车费" align="center"></el-table-column>
        <el-table-column prop="exp4" label="油费" align="center"></el-table-column>
        <el-table-column prop="exp5" label="过路费" align="center"></el-table-column>
        <el-table-column prop="exp6" label="招待费" align="center"></el-table-column>
        <el-table-column prop="expOther" label="其他" align="center"></el-table-column>
        <el-table-column prop="expTotal" label="小计" align="center"></el-table-column>
        <el-table-column prop="clientname" label="招待人员" align="center"></el-table-column>
        <el-table-column prop="remark" label="费用备注" align="center"></el-table-column>
        <el-table-column prop="userName" label="报销人" align="center"></el-table-column>
        <el-table-column label="报销凭证" headeralign="center" min-width="200">
          <template v-slot="{ row }">
            <div class="img-list">
              <el-image
                v-for="(url, imgIndex) in row.imgList"
                :key="imgIndex"
                style="width: 44px; height: 44px"
                :src="url"
                :preview-src-list="row.imgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <ExpenseDetail :visible.sync="detailVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import ExpenseDetail from './components/ExpenseDetail';

import { getRmbsmList, exportRmbsmList } from '@/api/expense';
import { getUserList } from '@/api/user';

export default {
  components: { TableHeader, ExpenseDetail },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        userType: 1,
        keyword: '',
        userId: '',
        dateRange: []
      },
      userOptions: [],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      detailVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getUserList() {
      const { data } = await getUserList({ pageNum: 1, pageSize: 9999 });
      const userData = data.list || [];
      this.userOptions = userData.map(item => ({
        label: item.name,
        value: item.id
      }));
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startTime = this.searchModel?.dateRange?.[0] ?? null;
      const endTime = this.searchModel?.dateRange?.[1] ?? null;

      const { data } = await getRmbsmList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      const tableData = data.list || [];
      tableData.forEach(item => {
        if (item.pics) {
          item.imgList = item.pics.split(',').map(item => {
            return this.$imgUrl + item;
          });
        } else {
          item.imgList = [];
        }
      });
      this.tableData = tableData;

      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    async handleExport() {
      if (!this.searchModel.userId) return this.$message.warning('请选择报销人');
      const startTime = this.searchModel?.dateRange?.[0] ?? null;
      const endTime = this.searchModel?.dateRange?.[1] ?? null;
      const params = { startTime, endTime, userType: 1, userId: this.searchModel.userId };

      try {
        const res = await exportRmbsmList(params);
        // 解析文件名
        let filename = '报销明细表.xlsx';
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
            filename = decodeURIComponent(filename);
          }
        }
        // 创建 Blob URL 并触发下载
        const blob = new Blob([res.data], { type: 'application/octet-stream' }); // 显式指定类型
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
      } finally {
        this.exportLoading = false;
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteDeviceById({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.getUserList();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
